import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    millions: (n: string) => `${n} mill`,
    thousands: (n: string) => `${n} mil`,
  },
  en: {
    millions: (n: string) => `${n}M`,
    thousands: (n: string) => `${n}K`,
  },
});
